// =====================================================================
// СТЕПЛЕРИ ТА ХІРУРГІЧНЕ ОБЛАДНАННЯ — Data Model
// =====================================================================

export interface EquipmentProduct {
  id: string;
  name: string;
  description: string;
  subcategory: string;
  images: string[];
}

export interface EquipmentSubcategory {
  id: string;
  name: string;
}

export const equipmentSubcategories: EquipmentSubcategory[] = [
  { id: 'all', name: 'Всі товари' },
  { id: 'trocars', name: 'Троакари' },
  { id: 'retractors', name: 'Ранорозширювачі' },
  { id: 'ligature-clamps', name: 'Лігатурні затискачі' },
  { id: 'hemoclips', name: 'Гемозатискачі' },
  { id: 'electric-staplers', name: 'Електричні ендоскопічні степлери' },
  { id: 'endoscopic-staplers', name: 'Ендоскопічні ріжучі степлери' },
  { id: 'linear-staplers', name: 'Лінійні степлери' },
  { id: 'specialized-staplers', name: 'Спеціалізовані степлери' },
  { id: 'ultrasound', name: 'Ультразвукове обладнання' },
];

const IMG = '/med_equipment_photos';

export const equipmentProducts: EquipmentProduct[] = [
  // ======================== ТРОАКАРИ ========================
  {
    id: 'trocar-extended',
    name: 'Розширений одноразовий троакар',
    description: 'Троакар використовується в загальних, торакальних, урологічних та гінекологічних ендоскопічних процедурах для забезпечення введення ендоскопічних інструментів.',
    subcategory: 'trocars',
    images: [
      `${IMG}/Розширений одноразовий троакар.webp`,
      `${IMG}/Розширений одноразовий троакар розміри.webp`,
    ],
  },
  {
    id: 'trocar-standard',
    name: 'Одноразовий троакар',
    description: 'Троакар використовується в загальних, торакальних, урологічних та гінекологічних ендоскопічних процедурах для забезпечення введення ендоскопічних інструментів.',
    subcategory: 'trocars',
    images: [
      `${IMG}/Одноразовий троакар.webp`,
      `${IMG}/Одноразовий троакар розміри.webp`,
    ],
  },
  {
    id: 'trocar-optical',
    name: 'Одноразовий троакар оптичний',
    description: 'Троакар використовується в загальних, торакальних, урологічних та гінекологічних ендоскопічних процедурах для забезпечення введення ендоскопічних інструментів.',
    subcategory: 'trocars',
    images: [
      `${IMG}/Одноразовий троакар оптичний.webp`,
      `${IMG}/Одноразовий троакар оптичний розміри.webp`,
    ],
  },
  {
    id: 'trocar-pediatric',
    name: 'Одноразовий троакар педіатричний',
    description: 'Троакар використовується в загальних, торакальних, урологічних та гінекологічних ендоскопічних процедурах для забезпечення введення ендоскопічних інструментів.',
    subcategory: 'trocars',
    images: [
      `${IMG}/Одноразовий троакар педіатричний.webp`,
      `${IMG}/Одноразовий троакар педіатричний розміри.webp`,
    ],
  },

  // ======================== РАНОРОЗШИРЮВАЧІ ========================
  {
    id: 'retractor-1',
    name: 'Одноразовий ранорозширювач',
    description: 'Цей одноразовий ранорозширювач/протектор складається із зовнішнього кільця, імплантованого кільця та прохідного каналу, кожен з яких може еластично деформуватися після навантаження силою в поздовжньому або радіальному напрямку, а також еластично відновлюватися у вихідне положення після звільнення від сили. На додаток до максимального втягування рани для розширення поля зору під час операції, прохідний канал може ефективно відокремити тканини розрізу від внутрішніх органів у черевній порожнині, щоб запобігти їхньому забрудненню. У клінічному застосуванні лікарі можуть вибрати одноразові ранорозширювачі відповідного розміру відповідно до розташування та розміру операційного розрізу.',
    subcategory: 'retractors',
    images: [
      `${IMG}/Одноразовий ранорозширювач.webp`,
      `${IMG}/Одноразовий ранорозширювач розміри.webp`,
    ],
  },
  {
    id: 'retractor-2',
    name: 'Одноразовий ранорозширювач',
    description: 'Цей одноразовий ранорозширювач/протектор складається із зовнішнього кільця, імплантованого кільця та прохідного каналу, кожен з яких може еластично деформуватися після навантаження силою в поздовжньому або радіальному напрямку, а також еластично відновлюватися у вихідне положення після звільнення від сили. На додаток до максимального втягування рани для розширення поля зору під час операції, прохідний канал може ефективно відокремити тканини розрізу від внутрішніх органів у черевній порожнині, щоб запобігти їхньому забрудненню.',
    subcategory: 'retractors',
    images: [
      `${IMG}/Одноразовий ранорозширювач 2.webp`,
      `${IMG}/Одноразовий ранорозширювач 2 розміри.webp`,
    ],
  },
  {
    id: 'retractor-cover-1',
    name: 'Одноразовий ранорозширювач та чохол комплекти',
    description: 'Цей одноразовий ранорозширювач/протектор складається із зовнішнього кільця, імплантованого кільця та прохідного каналу, кожен з яких може еластично деформуватися після навантаження силою в поздовжньому або радіальному напрямку, а також еластично відновлюватися у вихідне положення після звільнення від сили. На додаток до максимального втягування рани для розширення поля зору під час операції, прохідний канал може ефективно відокремити тканини розрізу від внутрішніх органів у черевній порожнині, щоб запобігти їхньому забрудненню.',
    subcategory: 'retractors',
    images: [
      `${IMG}/Одноразовий ранорозширювач та чохол комплекти.webp`,
      `${IMG}/Одноразовий ранорозширювач та чохол комплекти розміри.webp`,
    ],
  },
  {
    id: 'retractor-cover-2',
    name: 'Одноразовий ранорозширювач та чохол комплекти',
    description: 'Цей одноразовий ранорозширювач/протектор складається із зовнішнього кільця, імплантованого кільця та прохідного каналу, кожен з яких може еластично деформуватися після навантаження силою в поздовжньому або радіальному напрямку, а також еластично відновлюватися у вихідне положення після звільнення від сили.',
    subcategory: 'retractors',
    images: [
      `${IMG}/Одноразовий ранорозширювач та чохол комплекти 2.webp`,
      `${IMG}/Одноразовий ранорозширювач та чохол комплекти 2 розміри.webp`,
    ],
  },
  {
    id: 'retractor-cover-3',
    name: 'Одноразовий ранорозширювач та чохол комплекти',
    description: 'Цей одноразовий ранорозширювач/протектор складається із зовнішнього кільця, імплантованого кільця та прохідного каналу, кожен з яких може еластично деформуватися після навантаження силою в поздовжньому або радіальному напрямку, а також еластично відновлюватися у вихідне положення після звільнення від сили.',
    subcategory: 'retractors',
    images: [
      `${IMG}/Одноразовий ранорозширювач та чохол комплекти 3.webp`,
      `${IMG}/Одноразовий ранорозширювач та чохол комплекти 3 розміри.webp`,
    ],
  },
  {
    id: 'retractor-cover-4',
    name: 'Одноразовий ранорозширювач та чохол комплекти',
    description: 'Цей одноразовий ранорозширювач/протектор складається із зовнішнього кільця, імплантованого кільця та прохідного каналу, кожен з яких може еластично деформуватися після навантаження силою в поздовжньому або радіальному напрямку, а також еластично відновлюватися у вихідне положення після звільнення від сили.',
    subcategory: 'retractors',
    images: [
      `${IMG}/Одноразовий ранорозширювач та чохол комплекти 4.webp`,
      `${IMG}/Одноразовий ранорозширювач та чохол комплекти 4 розміри.webp`,
    ],
  },

  // ======================== ЛІГАТУРНІ ЗАТИСКАЧІ ========================
  {
    id: 'ligature-with-applicator',
    name: 'Одноразовий лігатурний затискач (з аплікатором)',
    description: 'Лігатурний затискач — це інструмент, який використовується під час лапароскопічних операцій. Він дозволяє коагулювати без колатерального термічного ефекту, чим робить таку коагуляцію значно безпечнішою.',
    subcategory: 'ligature-clamps',
    images: [
      `${IMG}/Одноразовий лігатурний затискач (з аплікатором).webp`,
      `${IMG}/Одноразовий лігатурний затискач (з аплікатором) розміри.webp`,
    ],
  },
  {
    id: 'ligature-yellow',
    name: 'Одноразовий лігатурний затискач (без аплікатора) жовта',
    description: 'Кліпси для лігування є стерильними та одноразовими виробами. Виготовлені з полімеру, що не розсмоктується, він є придатним для імплантації. Розроблений у різних розмірах, щоб задовольнити потреби в оклюзії та закритті тканин різних анатомічних структур, як при відкритих, так і при лапароскопічних операціях. Кліпси виготовлені з полімерних матеріалів, придатних для імплантації, щоб забезпечити довготривалу безпеку пацієнта для гемостатичного закриття тканин.',
    subcategory: 'ligature-clamps',
    images: [
      `${IMG}/Одноразовий лігатурний затискач (без аплікатора) жовта.webp`,
      `${IMG}/Одноразовий лігатурний затискач (без аплікатора) жовта розміри.webp`,
    ],
  },
  {
    id: 'ligature-green',
    name: 'Одноразовий лігатурний затискач (без аплікатора) зелена',
    description: 'Кліпси для лігування є стерильними та одноразовими виробами. Виготовлені з полімеру, що не розсмоктується, він є придатним для імплантації. Розроблений у різних розмірах, щоб задовольнити потреби в оклюзії та закритті тканин різних анатомічних структур, як при відкритих, так і при лапароскопічних операціях.',
    subcategory: 'ligature-clamps',
    images: [
      `${IMG}/Одноразовий лігатурний затискач (без аплікатора) зелена.webp`,
      `${IMG}/Одноразовий лігатурний затискач (без аплікатора) зелена розміри.webp`,
    ],
  },
  {
    id: 'ligature-purple',
    name: 'Одноразовий лігатурний затискач (без аплікатора) фіолетова',
    description: 'Кліпси для лігування є стерильними та одноразовими виробами. Виготовлені з полімеру, що не розсмоктується, він є придатним для імплантації. Розроблений у різних розмірах, щоб задовольнити потреби в оклюзії та закритті тканин різних анатомічних структур, як при відкритих, так і при лапароскопічних операціях.',
    subcategory: 'ligature-clamps',
    images: [
      `${IMG}/Одноразовий лігатурний затискач (без аплікатора) фіолетова.webp`,
      `${IMG}/Одноразовий лігатурний затискач (без аплікатора) фіолетова розміри.webp`,
    ],
  },

  // ======================== ГЕМОЗАТИСКАЧІ ========================
  {
    id: 'hemoclip-1',
    name: 'Одноразовий гемозатискач',
    description: 'Одноразовий гемозатискач (ендокліпатор) — це шлунково-кишковий ендоскопічний кліп, довготривалий, біоабсорбуючий, призначений для тривалої імплантації (>30 днів) в шлунково-кишковому тракті під час ендоскопічної операції з метою гемостазу при дефектах слизової оболонки/підслизової оболонки, при виразках, що кровоточать, при ураженні артерій та поліпів. Це металевий пристрій із застібкою та одноразовим аплікатором. Одноразовий ендокліпатор є обертовим (360°) і репозиційним, його можна відкривати, закривати і повертати кілька разів перед тим, як встановити.',
    subcategory: 'hemoclips',
    images: [
      `${IMG}/Одноразовий гемозатискач.webp`,
      `${IMG}/Одноразовий гемозатискач розміри.webp`,
    ],
  },
  {
    id: 'hemoclip-2',
    name: 'Одноразовий гемозатискач',
    description: 'Одноразовий гемозатискач (ендокліпатор) — це шлунково-кишковий ендоскопічний кліп, довготривалий, біоабсорбуючий, призначений для тривалої імплантації (>30 днів) в шлунково-кишковому тракті під час ендоскопічної операції з метою гемостазу при дефектах слизової оболонки/підслизової оболонки, при виразках, що кровоточать, при ураженні артерій та поліпів.',
    subcategory: 'hemoclips',
    images: [
      `${IMG}/Одноразовий гемозатискач 2.webp`,
      `${IMG}/Одноразовий гемозатискач 2 розміри.webp`,
    ],
  },

  // ======================== ЕЛЕКТРИЧНІ ЕНДОСКОПІЧНІ СТЕПЛЕРИ ========================
  {
    id: 'electric-stapler-1',
    name: 'Одноразовий електричний ендоскопічний ріжучий степлер',
    description: 'Одноразовий електричний ріжучий степлер з касетою — це стерильний ручний хірургічний інструмент, що живиться від батарейок, призначений для використання під час ендоскопічних хірургічних процедур для швидкого розсічення та резекції тканин, створення анастомозів, а також під час відкритої хірургічної операції. Пристрій працює за допомогою механізму, за допомогою якого він розрізає тканини і одночасно накладає кілька лінійних рядів хірургічних скоб на отримані краї по лінії розрізу, з живленням від двигуна в ручці. Цей тип степлера доступний у 3 варіантах довжини робочої частини: 30мм, 45мм, 60мм. Існує 6 моделей: SEA SEB SEC SEF SDE SDD. Степлер SEA SEB SEC сумісний з касетою SERA SERB SERC.',
    subcategory: 'electric-staplers',
    images: [
      `${IMG}/Одноразовий електричний ендоскопічний ріжучий степлер.webp`,
      `${IMG}/Одноразовий електричний ендоскопічний ріжучий степлер розміри.webp`,
    ],
  },
  {
    id: 'electric-stapler-cartridge-1',
    name: 'Касета для електричного ендоскопічного ріжучого степлера',
    description: 'Касета для одноразового електричного ріжучого степлера. Степлер та змінна касета працюють плавно та не застрягають, пристрій має хороші показники щодо створення анастомозу й шва, нова змінна касета може бути вжита щонайменше 5 разів та утворювати скоби у формі «В». Сумісність з МРТ: містить імплантований матеріал — нелегований титан.',
    subcategory: 'electric-staplers',
    images: [
      `${IMG}/Касета для електричного ендоскопічного ріжучого степлера.webp`,
      `${IMG}/Касета для електричного ендоскопічного ріжучого степлера розміри.webp`,
    ],
  },
  {
    id: 'electric-stapler-2',
    name: 'Одноразовий електричний ендоскопічний ріжучий степлер',
    description: 'Одноразовий електричний ріжучий степлер з касетою — це стерильний ручний хірургічний інструмент, що живиться від батарейок, призначений для використання під час ендоскопічних хірургічних процедур для швидкого розсічення та резекції тканин, створення анастомозів. Доступний у 3 варіантах довжини робочої частини: 30мм, 45мм, 60мм.',
    subcategory: 'electric-staplers',
    images: [
      `${IMG}/Одноразовий електричний ендоскопічний ріжучий степлер 2.webp`,
      `${IMG}/Одноразовий електричний ендоскопічний ріжучий степлер 2 розміри.webp`,
    ],
  },
  {
    id: 'electric-stapler-cartridge-2',
    name: 'Касета для електричного ендоскопічного ріжучого степлера',
    description: 'Касета для одноразового електричного ріжучого степлера. Нова змінна касета може бути вжита щонайменше 5 разів та утворювати скоби у формі «В». Край зони розрізу повинен бути тонким і без задирок. Сумісність з МРТ: титанові імплантати сумісні з магнітно-резонансною томографією.',
    subcategory: 'electric-staplers',
    images: [
      `${IMG}/Касета для електричного ендоскопічного ріжучого степлера 2.webp`,
      `${IMG}/Касета для електричного ендоскопічного ріжучого степлера 2 розміри.webp`,
    ],
  },
  {
    id: 'electric-stapler-cartridge-3',
    name: 'Касета для електричного ендоскопічного ріжучого степлера',
    description: 'Касета для одноразового електричного ріжучого степлера. Доступна у 3 варіантах довжини: 30мм, 45мм, 60мм. Скоби у формі «В». Сумісність з МРТ: титанові імплантати сумісні з магнітно-резонансною томографією.',
    subcategory: 'electric-staplers',
    images: [
      `${IMG}/Касета для електричного ендоскопічного ріжучого степлера 3.webp`,
      `${IMG}/Касета для електричного ендоскопічного ріжучого степлера 3 розміри.webp`,
    ],
  },
  {
    id: 'electric-stapler-cartridge-4',
    name: 'Касета для електричного ендоскопічного ріжучого степлера',
    description: 'Касета для одноразового електричного ріжучого степлера. Край зони розрізу тонкий і без задирок, довжина анастомозу щонайменше в 1,5 рази перевищує довжину розрізу. Сумісність з МРТ.',
    subcategory: 'electric-staplers',
    images: [
      `${IMG}/Касета для електричного ендоскопічного ріжучого степлера 4.webp`,
      `${IMG}/Касета для електричного ендоскопічного ріжучого степлера 4 розміри.webp`,
    ],
  },

  // ======================== ЕНДОСКОПІЧНІ РІЖУЧІ СТЕПЛЕРИ ========================
  {
    id: 'endo-cutting-stapler',
    name: 'Одноразовий ендоскопічний ріжучий степлер зі змінними картриджами',
    description: 'Одноразовий ендоскопічний ріжучий степлер працює за допомогою ручного механізму, за допомогою якого він розрізає тканини і одночасно відокремлює тканину від центральної лінії, накладає 6 рядів хірургічних скоб в шаховому порядку на окремій ділянці тканини. Доступний у 3 варіантах довжини робочої частини: 30мм, 45мм, 60мм. Степлер SLCA сумісний з картриджами SLCRE/SLCRF.',
    subcategory: 'endoscopic-staplers',
    images: [
      `${IMG}/Одноразовий ендоскопічний ріжучий степлер зі змінними картриджами.webp`,
      `${IMG}/Одноразовий ендоскопічний ріжучий степлер зі змінними картриджами розміри.webp`,
    ],
  },
  {
    id: 'endo-cutting-cartridges',
    name: 'Одноразові касети для ендоскопічного ріжучого степлера',
    description: 'Касети для одноразового ендоскопічного ріжучого степлера. Змінний картридж працює плавно та не застрягає, може бути вжитий щонайменше 5 разів та утворювати скоби у формі «В». Степлер SLCA сумісний з картриджами SLCRE/SLCRF.',
    subcategory: 'endoscopic-staplers',
    images: [
      `${IMG}/Одноразові касети для ендоскопічного ріжучого степлера.webp`,
      `${IMG}/Одноразові касети для ендоскопічного ріжучого степлера розміри.webp`,
    ],
  },
  {
    id: 'endo-linear-cutting-stapler',
    name: 'Одноразовий ендоскопічний лінійний зшиваючо-ріжучий степлер',
    description: 'Одноразовий ендоскопічний ріжучий степлер працює за допомогою ручного механізму, за допомогою якого він розрізає тканини і одночасно відокремлює тканину від центральної лінії, накладає 6 рядів хірургічних скоб в шаховому порядку. Доступний у 3 варіантах довжини: 30мм, 45мм, 60мм. Сумісність з МРТ: титанові імплантати сумісні з МРТ. Степлер SLCA сумісний з картриджами SLCRE/SLCRF.',
    subcategory: 'endoscopic-staplers',
    images: [
      `${IMG}/Одноразовий ендоскопічний лінійний зшиваючо-ріжучий степлер.webp`,
      `${IMG}/Одноразовий ендоскопічний лінійний зшиваючо-ріжучий степлер розміри.webp`,
    ],
  },

  // ======================== ЛІНІЙНІ СТЕПЛЕРИ ========================
  {
    id: 'curved-stapler-1',
    name: 'Одноразовий вигнутий хірургічний степлер',
    description: 'Степлер з вигнутими ножами одноразового використання — це стерильний одноразовий хірургічний інструмент з вигнутою головкою, який ріже і скріплює. Пристрій забезпечить перев\'язку структур товстої кишки, коли потрібне їх тривале лігування. Пристрій працює за допомогою ручних механізмів: важеля, рухомої ручки, за допомогою яких він розрізає тканини і одночасно накладає кілька лінійних рядів хірургічних скоб на утворених краях.',
    subcategory: 'linear-staplers',
    images: [
      `${IMG}/Одноразовий вигнутий хірургічний степлер.webp`,
      `${IMG}/Одноразовий вигнутий хірургічний степлер розміри.webp`,
    ],
  },
  {
    id: 'curved-stapler-2',
    name: 'Одноразовий вигнутий хірургічний степлер',
    description: 'Степлер з вигнутими ножами одноразового використання — це стерильний одноразовий хірургічний інструмент з вигнутою головкою, який ріже і скріплює. Пристрій працює за допомогою ручних механізмів: важеля, рухомої ручки.',
    subcategory: 'linear-staplers',
    images: [
      `${IMG}/Одноразовий вигнутий хірургічний степлер 2.webp`,
      `${IMG}/Одноразовий вигнутий хірургічний степлер 2 розміри.webp`,
    ],
  },
  {
    id: 'linear-cutting-cartridge-1',
    name: 'Одноразова касета для лінійного ріжучого степлера',
    description: 'Лінійно-ріжучий степлер одноразового використання та касета — це стерильний хірургічний інструмент, призначений для накладання хірургічних скоб на тканини під час відкритих операцій (включаючи абдомінальну, гінекологічну, педіатричну або торакальну хірургію). Він розміщує подвійний ряд титанових скоб у шаховому порядку і доступний з довжиною лінії скоб 30 мм, 45 мм, 60 мм, 75 мм і 90 мм.',
    subcategory: 'linear-staplers',
    images: [
      `${IMG}/Одноразова касета для лінійного ріжучого степлера.webp`,
      `${IMG}/Одноразова касета для лінійного ріжучого степлера розміри.webp`,
    ],
  },
  {
    id: 'linear-cutting-stapler',
    name: 'Одноразовий лінійний зшиваючий ріжучий степлер',
    description: 'Лінійний зшиваючий ріжучий степлер одноразового використання з касетою — це стерильний одноразовий хірургічний інструмент, призначений для накладання хірургічних скоб на тканини в абдомінальній, гінекологічній, торакальній та педіатричній хірургії для розсічення, резекції та створення анастомозів. Пристрій працює за допомогою ручного механізму, за допомогою якого він розрізає тканини та одночасно накладає чотири лінійні ряди хірургічних скоб з картриджу. Сумісність з МРТ.',
    subcategory: 'linear-staplers',
    images: [
      `${IMG}/Одноразовий лінійний зшиваючий ріжучий степлер.webp`,
      `${IMG}/Одноразовий лінійний зшиваючий ріжучий степлер розміри.webp`,
    ],
  },
  {
    id: 'linear-cutting-cartridge-2',
    name: 'Одноразова касета для лінійного ріжучого степлера',
    description: 'Касета для лінійно-ріжучого степлера. Подвійний ряд титанових скоб у шаховому порядку. Доступна з довжиною лінії скоб 30 мм, 45 мм, 60 мм, 75 мм і 90 мм. Сумісність з МРТ: титанові імплантати сумісні з МРТ.',
    subcategory: 'linear-staplers',
    images: [
      `${IMG}/Одноразова касета для лінійного ріжучого степлера 2.webp`,
      `${IMG}/Одноразова касета для лінійного ріжучого степлера 2 розміри.webp`,
    ],
  },
  {
    id: 'linear-sewing-cutting-cartridge',
    name: 'Одноразова касета для лінійного зшиваючого ріжучого степлера',
    description: 'Лінійний зшиваючий ріжучий степлер одноразового використання з касетою — це стерильний одноразовий хірургічний інструмент, призначений для накладання хірургічних скоб на тканини в абдомінальній, гінекологічній, торакальній та педіатричній хірургії для розсічення, резекції та створення анастомозів. Сумісність з МРТ: титанові імплантати сумісні з МРТ.',
    subcategory: 'linear-staplers',
    images: [
      `${IMG}/Одноразова касета для лінійного зшиваючого ріжучого степлера.webp`,
      `${IMG}/Одноразова касета для лінійного зшиваючого ріжучого степлера розміри.webp`,
    ],
  },
  {
    id: 'linear-sewing-stapler-1',
    name: 'Лінійно-зшиваючий степлер одноразового використання та касета',
    description: 'Лінійно-зшиваючий степлер одноразового використання заряджений касетою та додатково ще одна в комплекті — це стерильний хірургічний інструмент, призначений для накладання хірургічних скоб на тканини під час відкритих операцій (включаючи абдомінальну, гінекологічну, педіатричну або торакальну хірургію). Подвійний ряд титанових скоб у шаховому порядку. Довжина лінії скоб: 30 мм, 45 мм, 60 мм, 75 мм і 90 мм. Сумісність з МРТ.',
    subcategory: 'linear-staplers',
    images: [
      `${IMG}/Лінійно-зшиваючий степлер одноразового використання та касета.webp`,
      `${IMG}/Лінійно-зшиваючий степлер одноразового використання та касета розміри.webp`,
    ],
  },
  {
    id: 'linear-sewing-stapler-2',
    name: 'Лінійно-зшиваючий степлер одноразового використання та касета',
    description: 'Лінійно-зшиваючий степлер заряджений касетою та додатково ще одна в комплекті. Призначений для відкритих операцій (абдомінальна, гінекологічна, педіатрична або торакальна хірургія). Подвійний ряд титанових скоб у шаховому порядку. Сумісність з МРТ.',
    subcategory: 'linear-staplers',
    images: [
      `${IMG}/Лінійно-зшиваючий степлер одноразового використання та касета 2.webp`,
      `${IMG}/Лінійно-зшиваючий степлер одноразового використання та касета 2 розміри.webp`,
    ],
  },

  // ======================== СПЕЦІАЛІЗОВАНІ СТЕПЛЕРИ ========================
  {
    id: 'circumcision-stapler',
    name: 'Степлер для обрізання',
    description: 'Степлер для обрізання активується шляхом сильного стискання ручок, щоб розмістити один ряд скоб і зшити два шари тканини разом. Оскільки шовні скоби добре вирівняні, мають однакову відстань і щільність шва — це дозволяє уникнути проблем, які можуть виникнути при накладанні шва вручну та забезпечити швидке відновлення і скоротити операційний час. Одноразовий циркулярний степлер може використовуватися в урології для проведення обрізання для чоловіків, як дорослих, так і дітей. Діти повинні бути старше 6 років. Не застосовувати для новонароджених.',
    subcategory: 'specialized-staplers',
    images: [
      `${IMG}/Степлер для обрізання.webp`,
      `${IMG}/Степлер для обрізання розміри.webp`,
    ],
  },
  {
    id: 'circular-stapler-1',
    name: 'Одноразовий циркулярний степлер',
    description: 'Цей одноразовий циркулярний степлер активується шляхом сильного стискання ручок, щоб розмістити один ряд скоб, скоби виконані у формі щоб зшити два шари тканини разом. Оскільки шовні скоби добре вирівняні та мають однакову відстань і щільність шва — це дозволяє уникнути проблем, які можуть виникнути при накладанні шва вручну, забезпечити швидке відновлення, і скоротити операційний час.',
    subcategory: 'specialized-staplers',
    images: [
      `${IMG}/Одноразовий циркулярний степлер.webp`,
      `${IMG}/Одноразовий циркулярний степлер розміри.webp`,
    ],
  },
  {
    id: 'circular-stapler-2',
    name: 'Одноразовий циркулярний степлер',
    description: 'Цей одноразовий циркулярний степлер активується шляхом сильного стискання ручок, щоб розмістити один ряд скоб. Шовні скоби добре вирівняні та мають однакову відстань і щільність шва — це дозволяє уникнути проблем при ручному накладанні шва.',
    subcategory: 'specialized-staplers',
    images: [
      `${IMG}/Одноразовий циркулярний степлер 2.webp`,
      `${IMG}/Одноразовий циркулярний степлер 2 розміри.webp`,
    ],
  },
  {
    id: 'hemorrhoidal-stapler',
    name: 'Одноразовий гемороїдальний степлер',
    description: 'Гемороїдальний степлер одноразового використання — це стерильний, одноразовий хірургічний інструмент, призначений для накладення хірургічних скоб на тканини анального каналу для лікування геморою, зокрема для процедури лікування пролапсу та гемерою (ППГ). Він дозволяє наносити кільцевий розміщений подвійний ряд скоб, одночасно резекцію сегмента стислого м\'якого тканини. Сумісність з МРТ: титанові імплантати сумісні з МРТ.',
    subcategory: 'specialized-staplers',
    images: [
      `${IMG}/Одноразовий гемороїдальний степлер.webp`,
      `${IMG}/Одноразовий гемороїдальний степлер розміри.webp`,
    ],
  },
  {
    id: 'purse-string-stapler',
    name: 'Степлер для накладання кисетного шва одноразового використання',
    description: 'Одноразовий степлер накладає хірургічний шов з нейлонової монофіламентної нитки, що не розсмоктується, і утримується на місці скобами. Скоби закріплюються на анатомічних структурах або органах, де потрібен кисетний шов.',
    subcategory: 'specialized-staplers',
    images: [
      `${IMG}/Степлер для накладання кисетного шва одноразового використання.webp`,
      `${IMG}/Степлер для накладання кисетного шва одноразового використання розміри.webp`,
    ],
  },
  {
    id: 'skin-stapler',
    name: 'Степлер для шкіри одноразового використання',
    description: 'Одноразовий степлер для шкіри та пристрій для видалення скоб моделі SHP вводить прямокутні скоби з нержавіючої сталі для рутинного зашивання ран, які видаляються за допомогою спеціального пристрою для видалення скоб. Має належну якість швів та скорочує час операції.',
    subcategory: 'specialized-staplers',
    images: [
      `${IMG}/Степлер для шкіри одноразового використання.webp`,
      `${IMG}/Степлер для шкіри одноразового використання розміри.webp`,
    ],
  },
  {
    id: 'staple-remover',
    name: 'Пристрій для видалення скоб',
    description: 'Одноразовий степлер для шкіри та пристрій для видалення скоб моделі SHP вводить прямокутні скоби з нержавіючої сталі для рутинного зашивання ран, які видаляються за допомогою спеціального пристрою для видалення скоб. Має належну якість швів та скорочує час операції.',
    subcategory: 'specialized-staplers',
    images: [
      `${IMG}/Пристрій для видалення скоб.webp`,
      `${IMG}/Пристрій для видалення скоб додаток.webp`,
    ],
  },

  // ======================== УЛЬТРАЗВУКОВЕ ОБЛАДНАННЯ ========================
  {
    id: 'generator',
    name: 'Генератор',
    description: 'Технологія DITM (Depth intelligent Tissue Monitoring) дозволяє точно регулювати вихідну енергію для забезпечення найкращого ефекту запечатування при мінімальному термічному пошкодженні тканин. Вбудований двоядерний процесор DSP контролює імпеданс тканин — це дозволяє підняти швидкість різання та запечатування тканин при зменшенні термічного пошкодження. Відповідає стандарту США 510К. Завдяки функції самоперевірки, генератор може відслідковувати стан роботи в режимі реального часу, а журнал можна експортувати.',
    subcategory: 'ultrasound',
    images: [
      `${IMG}/Генератор.webp`,
      `${IMG}/Генератор додаток.webp`,
    ],
  },
  {
    id: 'handle-hp25',
    name: 'Рукоятка iScalpel HP25',
    description: 'Рукоятка iScalpel HP25 — це ергономічний та високонадійний елемент ультразвукової хірургічної системи, призначений для підключення та роботи з ультразвуковими ножицями та іншими інструментами серії iScalpel. Забезпечує стабільну передачу ультразвукової енергії, точний контроль та комфорт хірурга під час тривалих операцій. Довжина рукоятки: 13 см, діаметр: 2,5 см, довжина кабелю: 2,9 м, робоча частота: 55,5 кГц, до 120 циклів активації.',
    subcategory: 'ultrasound',
    images: [
      `${IMG}/РУКОЯТКА iScalpel HP25.webp`,
    ],
  },
  {
    id: 'handle-hp16',
    name: 'Рукоятка iScalpel HP16',
    description: 'Рукоятка iScalpel HP16 — це компактна та високоточна рукоятка ультразвукової хірургічної системи, спеціально розроблена для роботи з ультразвуковими ножицями iScalpel USS серії. Тонкий та компактний корпус, що забезпечує високу маневровість і точність рухів. Довжина рукоятки: 15 см, діаметр: 1,6 см, довжина кабелю: 2,9 м, робоча частота: 55,5 кГц, до 120 циклів активації. Сумісна з генератором USG10 Plus та ножицями USS серії.',
    subcategory: 'ultrasound',
    images: [
      `${IMG}/Рукоятка iScalpel HP16.webp`,
    ],
  },
  {
    id: 'scissors-hoc-ht7',
    name: 'Ультразвукові ножиці iScalpel HOC-HT7 серія',
    description: 'Ультразвукові ножиці iScalpel HOC-HT7 серії — це високоефективні хірургічні інструменти для надійної коагуляції судин великого діаметра (до 7 мм) та точного розсічення м\'яких тканин. Антиприлипальне покриття робочої частини, обертання на 360°, сумісність з рукояткою HP25. Модельний ряд: HOC-HT7 14 (14 см), HOC-HT7 23 (23 см), HOC-HT7 36 (36 см), HOC-HT7 45 (45 см). Діаметр штоку: 5,0 мм.',
    subcategory: 'ultrasound',
    images: [
      `${IMG}/Ультразвукові ножиці iScalpel НОС-НТ7 СЕРІЯ.webp`,
    ],
  },
  {
    id: 'scissors-uss',
    name: 'Ультразвукові ножиці iScalpel USS серія',
    description: 'Ультразвукові ножиці iScalpel USS серії — компактні та високоточні інструменти для відкритих та поверхневих хірургічних втручань. Точне ультразвукове різання та коагуляція з мінімальним термічним ушкодженням тканин. Сумісність з рукояткою HP16. Модельний ряд: USS9 (9 см), USS17 (17 см). Ширина розкриття бранш: 21,31 мм, довжина бранші: 16,1 мм.',
    subcategory: 'ultrasound',
    images: [
      `${IMG}/Ультразвукові ножиці iScalpel USS СЕРІЯ.webp`,
    ],
  },
];

export const totalEquipmentProducts = equipmentProducts.length;
